export default "__VITE_ASSET__B0At_$wB__"